jQuery(function () {

    /*
    Based on this example:
    http://scrollmagic.io/examples/basic/section_wipes_natural.html
    */

    var controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    // get all slides
    var slides = document.querySelectorAll("div.js-scroll-slidein");

    // create scene for every slide
    for (var i=0; i<slides.length; i++) {
        new ScrollMagic.Scene({
            triggerElement: slides[i]
        })
        .setPin(slides[i])
        .addTo(controller);
    }

});

// Scroll to top link

jQuery(window).scroll(function() {

    if (jQuery(window).scrollTop() > 500) {
        jQuery(".m-arrow__top").addClass("js-m-arrow__top--isactive");
    }

    if (jQuery(window).scrollTop() == 0) {
        jQuery(".m-arrow__top").removeClass("js-m-arrow__top--isactive");
    }

});

jQuery(".m-arrow__top a").bind("click",function(){

	var href = $(this).attr( 'href' ),
		$html = $('html, body');

	$html.animate({
		scrollTop: $( href ).offset().top
	});

});